module.exports = __webpack_public_path__ + "img/zcnr.c02e96d6.png";